import axios from 'axios';
import namespace from './namespace';
import LoggingEventsService from './../../../service/loggingEvents.js';
import SmtpConfigurationService from './../../../service/smtpConfiguration.js';
// import LoggingEventsService from './../../../../test/unit/helpers/loggingEventsServiceMock.js';
import AppService from './../../../service/app.js';
import { NAMESPACE as APP_NAMESPACE } from './../app';

let service = new LoggingEventsService(axios);
let smtpConfigurationService = new SmtpConfigurationService(axios);
let appService = new AppService();
const ERROR_MESSAGE_TITLE = 'Operation failed';
const CONFIRM_DELETE_MESSAGE = 'Are you sure you want to clear all errors?';

export default {
    async [namespace.actions.FETCH_LOGGING_EVENTS] ({ commit, state, dispatch }) {     
        try {
            state[namespace.state.WAITING_FOR_RESPONSE] = true;
            commit(namespace.mutations.SET_SMTP_CONFIGURATION_STATE, await smtpConfigurationService.fetchConfiguration());
            commit(namespace.mutations.SET_LOGGING_EVENTS, await service.getData());
            state[namespace.state.WAITING_FOR_RESPONSE] = false;
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    async [namespace.actions.DELETE_BY_ID] ({commit, state, dispatch}, loggingEventId) {
        try {
            commit(namespace.mutations.WAIT_FOR_DELETE_RESPONSE, loggingEventId);
            commit(namespace.mutations.DELETE_LOGGING_EVENT_BY_ID, await service.removeLoggingEventById(loggingEventId));       
            commit(namespace.mutations.STOP_WAIT_FOR_DELETE_RESPONSE, loggingEventId);
        } catch (err) {
            commit(namespace.mutations.STOP_WAIT_FOR_DELETE_RESPONSE, loggingEventId);
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    [namespace.actions.CONFIRM_DELETE_ALL]({commit, dispatch}, configurationId) {
        dispatch(
            APP_NAMESPACE.actions.SEND_NOTIFICATION, {
                receiver: 'MessageBox',
                payload: {
                    title: 'Confirm', message: CONFIRM_DELETE_MESSAGE, buttons: [
                        {
                            title: 'Cancel'
                        },
                        {
                            title: 'Clear',
                            onClickHandler: () => {
                                dispatch(namespace.actions.DELETE_LOGGING_EVENTS);
                            }
                        }
                    ]
                }
            },
            {root: true}
        );
    },
    async [namespace.actions.DELETE_LOGGING_EVENTS] ({commit, state, dispatch}) {
         try {
            let loggingEvents = state[namespace.state.LOGGING_EVENTS];
            state[namespace.state.WAITING_FOR_RESPONSE] = true;
            commit(namespace.mutations.CLEAR_LOGGING_EVENTS, await service.removeLoggingEvents(loggingEvents));       
            state[namespace.state.WAITING_FOR_RESPONSE] = false;
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    [namespace.actions.SET_UP_SERVICE] ({}, payload) {
        if (payload.service !== undefined) {
            service = payload.service;
        }
        if (payload.smtpConfigurationService !== undefined) {
            smtpConfigurationService = payload.smtpConfigurationService;
        }
        if (payload.prefix !== undefined) {
            service.backendUrl = payload.prefix;
            smtpConfigurationService.backendUrl = payload.prefix;
        }
    },
    [namespace.actions.HANDLE_ERROR] ({ commit, state, dispatch }, error) { 
        state[namespace.state.WAITING_FOR_RESPONSE] = false;   
        const message = appService.extractMessageFromErrorObject(error);
        dispatch(
            APP_NAMESPACE.actions.SEND_NOTIFICATION, {
                receiver: 'MessageBox', 
                payload: {title: ERROR_MESSAGE_TITLE, message: message}
            }, 
            {root: true}
        );
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/loggingEvents/actions.js